module.exports = __webpack_public_path__ + "static/img/major_pictgrid5_800x676.f70b462.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/major_pictgrid5_800x676.jpg
// module id = n+xw
// module chunks = 0